/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function() {
	return class LassoRegister {
		constructor(options) {
			this._features = options.features;

			this._element = this._features['ContentViewDOM'].getNode();
			this._content = options.content;
			this._features['LassoSelect'].register(this._element, this._content/*tabContent*/);
		}

		destroy() {
			this._features['LassoSelect'].deregister(this._element, this._content);
		}
	};
});
